<p>vakdashboard-table-totaal-row works!</p>
